import React from "react";
import logo from "../../../img/big/clear-logo.webp";
import LanguageComponent from "../language/language.component";

export default function ClearLogoComponent(props) {
  return (
    <div className="bg-backgroundSecondary text-foregroundSecondary">
      <div className="d-f-c-c p-h-10">
        <LanguageComponent />
        <img src={logo} alt="logo" className={props.class} />
      </div>
    </div>
  );
}
